import { render } from "./AddPermissionModal.vue?vue&type=template&id=3e8dcbef&ts=true"
import script from "./AddPermissionModal.vue?vue&type=script&lang=ts"
export * from "./AddPermissionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__